<template>
  <div data-app>
    <div class="tm-functions-description">
      <preloader :is-visible="isLoading"/>
      <div v-if="!isLoading && local_page_keys !== null" class="uk-card uk-card-small uk-card-default" style="min-height: calc(100vh - 30px);">
        <!--шапка-->
        <div class="uk-card-header">
          <div class="uk-grid uk-flex-middle" data-uk-grid>
            <div class="uk-width-expand">
              <div v-if="(role !== 'pro-retoucher' && ( isShowSelectUser() && chosenUser ))  || role === 'retoucher' " class="uk-card-title uk-margin-remove-top">
                {{ local_page_keys.description_title_header }}
              </div>
              <div v-else class="uk-card-title uk-margin-remove-top">
                {{ local_page_keys.title_functions_description }}
              </div>
            </div>
            <div class="uk-width-auto">
              <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                <!--выбор ретушера-->
                <div v-if="isShowSelectUser()" class="uk-position-relative">
                  <span v-if="loadingRetoucherData" class="uk-icon uk-spinner uk-position-center-left" style="left: -30px;" data-uk-spinner></span>
                  <v-select
                    id="usersSelect"
                    :options="formattedUserForHistory()"
                    label="text"
                    name="usersSelect"
                    v-model="chosenUser"
                    :reduce="_function => _function.value"
                    :clearable="true"
                    @input="selectRetoucher()"
                    class="tm-v-select"
                    style="width: 500px;"
                    placeholder="--">
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"/>
                    </template>
                  </v-select>
                </div>
                <!--поиск-->
                <div>
                  <div class="uk-search uk-search-default" style="width: 300px;">
                    <span data-uk-search-icon class="uk-icon uk-search-icon"></span>
                    <input
                      class="uk-search-input"
                      v-model="searchString"
                      type="search"
                      :placeholder="local_page_keys.search">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FunctionDescriptionTable
          :functions="functions"
          :local_page_keys="local_page_keys"
          :searchString="searchString"
          :role="role"
          :isLoading="isLoading"
          :chosenUser="chosenUser"
          :chosenUserBannedFunctions="retoucherBannedFunctionsList"
          @openView="openView"
          @openViewVideo="openViewVideo"
          @copyLink="copyLink"/>
        <FunctionInfoDescriptionDialog
          :name="info_name"
          :function_name="functionName"
          :text="info_text"
          :video="info_video"
          :show="showDialog"
          :items="items"
          :showDialogFaceValue="computedFaceValue"
          @hide="showDialog = false"
          v-if="showDialog"
          @copyLink="copyLink"/>
        <FunctionVideoDialog
          :show="showVideoDialog"
          @hide="showVideoDialog = false"
          v-if="showVideoDialog"/>
        <FunctionGalleryDialog
          :currentIndex="currentExampleCarouselIndex"
          :show="showDialog6"
          :items="items"
          :showDialogFaceValue="computedFaceValue"
          style="z-index: 2000"
          @hide="showDialog6 = false"
          @catchOnHide="handleHideEvent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import validateImgExp from '../../../filters/validateImgExp'
import FunctionInfoDescriptionDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDescriptionDialog";
import FunctionDescriptionTable from "../Tables/FunctionDescriptionTable";
import FunctionGalleryDialog from "@/pages/Dashboard/Components/Dialogs/FunctionGalleryDialog";
import FunctionVideoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionVideoDialog";
import Preloader from "../Components/Preloader";

export default {
  name: "FunctionsDescription",
  components: {
    FunctionDescriptionTable,
    Preloader,
    FunctionInfoDescriptionDialog,
    FunctionGalleryDialog,
    FunctionVideoDialog
  },
  data: () => ({
    local_page_keys: null,
    info_text: null,
    info_name: null,
    info_video: null,
    functionName: null,
    showDialogFaceValue:{},
    items: [
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
    ],
    showDialog: false,
    showVideoDialog: false,
    filters: [validateImgExp],
    isLoading: true,
    functionsList: [],
    searchString: '',
    capacities: [],
    types: [],
    currentExampleCarouselIndex: 0,
    showDialog6: false,
    role: null,
    functionsData: [],
    retoucherList: [],
    chosenUser: null,
    retoucherBannedFunctionsList:{},
    loadingRetoucherData: false
  }),
  computed: {
    functions() {
      return this.functionsData.filter(func => func.id !== 250 && func.id !== 253).map(func => {
        func.functionTypes = func.types ? func.types.map(type => type.name) : [];
        let typeCapacity = func.types ? func.types.filter(type => type.name == 'capacity') : [];
        if (typeCapacity && typeCapacity[0] && typeCapacity[0].additional) {
          func.capacities = JSON.parse(typeCapacity[0].additional);
        }
        if (func.elements) {
          func.elements = func.elements.map(function (element) {
            element.number = parseInt(element.name.replace(/\D/g, ""));
            return element;
          }).sort((a, b) => (a['number'] > b['number']) ? 1 : ((b['number'] > a['number']) ? -1 : 0));
        }
        return func;
      });
    },
    computedFaceValue(){
      return this.showDialogFaceValue;
    },
  },
  methods: {
    handleHideEvent(payload){
      if ('parent_function_obj' in payload && payload.parent_function_obj
          &&  Object.keys( payload.parent_function_obj).length > 0) {
        this.openView( payload.parent_function_obj)
      }
    },
    async getFunctionElementList() {
      await this.$store.dispatch('functionsEdit/functionsListDescription', {user_id: this.chosenUser});
      let data = this.$store.getters['functionsEdit/functionsListDescription'];
      this.functionsData = data.descriptions;
      this.retoucherList = data.retouchers;
      if(this.functionsData.length > 0 && Number(this.chosenUser) > 0){
        for(const func of this.functionsData){
          this.retoucherBannedFunctionsList['f_'+func.id] = {
            name: func.name,
            function_id: func.id,
            user_id: this.chosenUser,
            function_state: false,
          }
          if(func && 'f_'+func.id in data.retoucherBannedFunctionsList && 'function_state' in data.retoucherBannedFunctionsList['f_'+func.id]){
            this.retoucherBannedFunctionsList['f_'+func.id]['function_state'] = Number(data.retoucherBannedFunctionsList['f_' + func.id]['function_state']) > 0;
          }
        }
      }


      this.isLoading = false;
    },
    openView(item) {
      const videoLesson = item.examples.filter(item => item.type === "video" && item.video_lesson);
      const links = item.examples.map(item => ({
        src_before: item.image_before,
        src_after: item.image_after
      }));
      this.showDialogFaceValue = item;
      this.info_name = item.translated;
      this.info_text = this.local_page_keys['instruction_' + item.name];
      // this.info_video = videoLesson[0].video_lesson;
      this.info_video = videoLesson.map(function (video) {
        return video.video_lesson;
      });
      this.items = links;
      this.showDialog = true;
      this.functionName = item.name;
      const url = window.location.href.split('#')[0] + '#' + item.name;
      window.history.pushState(null, null, url);
    },
    openViewVideo() {
      this.showVideoDialog = true;
    },
    copyLink(functionName) {
      if (functionName) {
        const targetURL = window.location.protocol + '//' + window.location.host + '/new_mvp/functions_description#' + functionName;
        const input = document.createElement('input');
        input.value = targetURL;
        document.body.appendChild(input);
        input.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(input);
        if (successful) {
          UIkit.notification({
            message: this.local_page_keys.link_copied,
            pos: 'top-center',
            status: 'success',
            timeout: 1500
          })
        }
      }
    },
    checkURLParams() {
      const currentURL = window.location.href;
      const parameterIndex = currentURL.indexOf('#');
      if (parameterIndex !== -1) {
        const nameFunction = currentURL.slice(parameterIndex + 1);
        const foundItemfunction = this.functions.find(item => item.name === nameFunction);
        if (foundItemfunction) {
          this.openView(foundItemfunction);
        }
      }
    },
    formattedUserForHistory() {
      const users = Object.values(this.retoucherList);
      return users.map(user => ({
        value: user.id,
        text: (user.name !== '' ? user.name : user.email) + ' (' + user.email + ')'
      }))
    },
    async selectRetoucher() {
      this.loadingRetoucherData = true;
      this.clearRetoucherData();
      await this.getFunctionElementList();
      this.loadingRetoucherData = false;
    },
    clearRetoucherData() {
      this.functionsData.forEach(obj => {
        obj.probability_for_user = 0;
        obj.average_rate_for_user_for_function_in_percentage = 0;
      });
    },
    isShowSelectUser() {
      const allowedRoles = ['admin', 'senior-retoucher', 'mini-admin'];
      return allowedRoles.includes(this.role);
    }
  },
  async mounted() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('order-infoBlock'), await this.$filtergetLocalisationPage('functions_elements'), await this.$filtergetLocalisationPage('ru_retoucher_translations'), await this.$filtergetLocalisationPage('services_lists_instructions'));
    this.role = await this.$store.getters['profile/role'];
    await this.getFunctionElementList();
    this.checkURLParams();
  },
  watch: {
    showDialog: {
      handler(v) {
        if (v) {
          document.documentElement.classList.add('uk-modal-page');
          setTimeout(function(){
            if(!document.documentElement.classList.contains('uk-modal-page')){
              document.documentElement.classList.add('uk-modal-page');
            }
          }, 800);
        } else {
          document.documentElement.classList.remove('uk-modal-page');
        }
      }
    },
  }
}
</script>